<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    {{ titulo }}
                </span>
                <div class="float-right" v-if="incluirCheckboxes">
                    <b-form-checkbox
                        :checked="selecionarTodos"
                        @change="toggleSelecionarTodos"
                        :indeterminate="indeterminado"
                    >
                        Selecionar todos
                    </b-form-checkbox>
                </div>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    :itens="comprometimentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="valor" slot-scope="data">{{
                        data.valor | currency
                    }}</template>
                    <template
                        slot="selecao"
                        slot-scope="data"
                        v-if="incluirSelecao"
                    >
                        <slot name="selecao" v-bind="data"></slot>
                    </template>
                    <template
                        slot="checkbox"
                        slot-scope="data"
                        v-if="incluirCheckboxes"
                    >
                        <b-form-checkbox
                            :checked="comprometimentosSelecionados.includes(data.idComprometimento)"
                            @change="toggleItemSelecionado(data.idComprometimento, $event)"
                        ></b-form-checkbox>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="comprometimentoAcoes" v-bind="data"></slot>
                        <comprometimento-anexos
                            :comprometimento="data"
                            :dataServico="pagamentosServicos"
                            :mostrarBtnInserir="false"
                            :mostrarBtnExcluir="false"
                            :isPagamento="isPagamento"
                        ></comprometimento-anexos>
                        <comprometimento-aprovadores
                            :comprometimento="data"
                            :dataServico="pagamentosServicos"
                            :isPagamento="isPagamento"
                        >
                        </comprometimento-aprovadores>
                        <pagamento-time-line
                            :pagamentosServicos="pagamentosServicos"
                            :comprometimento="data"
                        ></pagamento-time-line>
                        <historico
                            titulo="Histórico do Serviço"
                            tipo="I"
                            :servicos="pagamentosServicos"
                            :id="`${data.idComprometimento}`"
                        ></historico>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ComprometimentoAnexos from './../comprometimentos/ComprometimentoAnexos'
import ComprometimentoAprovadores from './../comprometimentos/ComprometimentoAprovadores'
import PagamentoTimeLine from './PagamentoTimeLine2'
import Historico from '../../../shared/components/Historico'

export default {
    props: {
        comprometimentos: {
            type: Array,
            default: () => []
        },

        pagamentosServicos: {
            type: Object,
            default: () => {}
        },

        incluirSelecao: {
            type: Boolean,
            default: false
        },

        incluirCheckboxes: {
            type: Boolean,
            default: false
        },

        titulo: {
            type: String,
            default: 'SERVIÇOS'
        },

        isPagamento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            comprometimentosSelecionados: [],
            selecionarTodos: false,
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'idComprometimento',
                    label: 'Id',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'contrato',
                    label: 'Contrato',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'tipo',
                    label: 'Tipo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap',
                    type: 'status'
                },
                {
                    key: 'processo',
                    label: 'Processo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'dataEmissao',
                    label: 'Data de Emissão',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'dataMovimento',
                    label: 'Data do Movimento',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'historico',
                    label: 'Histórico',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    type: 'status'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Qtd. Anexos'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        toggleSelecionarTodos(checked) {
            // Usa o valor checked do evento para determinar a ação
            if (checked) {
                this.comprometimentosSelecionados = this.comprometimentos.map(c => c.idComprometimento)
                this.selecionarTodos = true
            } else {
                this.comprometimentosSelecionados = []
                this.selecionarTodos = false
            }
            
            // Força a reatividade do Vue.js
            this.$nextTick(() => {
                this.$emit('comprometimentos-selecionados', [...this.comprometimentosSelecionados])
            })
        },

        toggleItemSelecionado(idComprometimento, checked) {
            if (checked) {
                // Adiciona o item se não estiver na lista
                if (!this.comprometimentosSelecionados.includes(idComprometimento)) {
                    this.comprometimentosSelecionados.push(idComprometimento)
                }
            } else {
                // Remove o item da lista
                const index = this.comprometimentosSelecionados.indexOf(idComprometimento)
                if (index > -1) {
                    this.comprometimentosSelecionados.splice(index, 1)
                }
            }
            this.verificarEstadoSelecionarTodos()
        },

        verificarEstadoSelecionarTodos() {
            const totalComprometimentos = this.comprometimentos.length
            const selecionados = this.comprometimentosSelecionados.length

            if (selecionados === 0) {
                this.selecionarTodos = false
            } else if (selecionados === totalComprometimentos) {
                this.selecionarTodos = true
            } else {
                this.selecionarTodos = false
            }

            // Força a reatividade do Vue.js
            this.$nextTick(() => {
                this.$emit('comprometimentos-selecionados', [...this.comprometimentosSelecionados])
            })
        }
    },

    created() {
        if (this.incluirSelecao) {
            this.campos.pop()
            this.campos.unshift({
                key: 'selecao',
                label: ''
            })
        }

        if (this.incluirCheckboxes) {
            this.campos.unshift({
                key: 'checkbox',
                label: '',
                thClass: 'text-center',
                tdClass: 'text-center'
            })
        }
    },

    computed: {
        indeterminado() {
            const selecionados = this.comprometimentosSelecionados.length
            const total = this.comprometimentos.length
            return selecionados > 0 && selecionados < total
        }
    },

    watch: {
        // Limpa as seleções quando a lista de comprometimentos muda
        comprometimentos() {
            this.comprometimentosSelecionados = []
            this.selecionarTodos = false
        }
    },

    components: {
        ComprometimentoAnexos,
        ComprometimentoAprovadores,
        PagamentoTimeLine,
        Historico
    }
}
</script>
